
import React from 'react';
import { useParams } from 'react-router-dom';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { UsersContent } from '@/components/admin/UsersContent';
import { UserProfile } from '@/components/admin/UserProfile';

export default function Users() {
  const { id } = useParams();

  return (
    <AdminLayout>
      {id ? <UserProfile /> : <UsersContent />}
    </AdminLayout>
  );
}
